const states = {
  CONNECTING: 'Connecting',
  READY: 'Ready',
  INCOMING: 'Incoming',
  ON_CALL: 'On call',
  OFFLINE: 'Offline'
}

export default states
